import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { DashboardProvider } from './context/dashboard-context';
import { DashboardComponent } from './dashboard-component';

export function DashboardFactory() {
    return (
        <BaseLayoutFactory>
            <DashboardProvider>
                <DashboardComponent />
            </DashboardProvider>
        </BaseLayoutFactory>
    );
}
